export default {
  name: "ErrorForbidden",
};
